var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07895 1.3418L9.21506 4.66874C9.71533 6.13373 10.866 7.28436 12.331 7.78464L15.6579 8.92074L12.3309 10.0569C10.866 10.5571 9.71533 11.7078 9.21505 13.1727L8.07895 16.4997L6.94284 13.1727C6.44257 11.7078 5.29193 10.5571 3.82694 10.0569L0.5 8.92074L3.82695 7.78464C5.29193 7.28436 6.44257 6.13373 6.94284 4.66874L8.07895 1.3418Z",
    fill: "#EE7A45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9736 0.5C14.3792 1.68778 15.3121 2.6207 16.4999 3.02632C15.3121 3.43193 14.3792 4.36485 13.9736 5.55263C13.568 4.36485 12.6351 3.43193 11.4473 3.02632C12.6351 2.6207 13.568 1.68778 13.9736 0.5Z",
    fill: "#EE7A45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.a066f5cb990e86b0a4aa018b7bc05e38.svg";
export { ForwardRef as ReactComponent };